<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        Predict Schedule Date : {{ startDate | date:'M/d/yyyy' }}
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
        <mat-icon>close</mat-icon>
    </button>
</div>
  
  <mat-dialog-content class="mat-typography">

    <div class="prediction-table-container">
        <table class="prediction-table">      
          <thead>
            <tr>
              <th class="select-column"></th>
              <th>Predicted<br>Gas(cfm)</th>
              @if (showPredictedGas2) {
                <th>Predicted<br>Gas2(cfm)</th>
              }
              <th>Fat</th>
              <th>Carbs</th>
              <th>Protien</th>
              <th>Stream Name</th>
              <th>Tip Fee</th>
              <th>Haul Cost</th>
              <th>CI#</th>
            </tr>
          </thead>      
          <tbody>      
            @for (group of predictionGroups; track group.groupIndex) {      
              @for ( stream of group.streams; track stream.streamId + '-' + $index; let streamIndex = $index) {      
                <tr>
      
                  <!-- Show these columns only for the FIRST stream -->
                  @if (streamIndex === 0) {      
                    <!-- CHECKBOX + TOTAL TIP FEE -->
                    <td class="selection-cell" [attr.rowspan]="group.streams.length">
                      <mat-checkbox [(ngModel)]="group.selected"
                        (ngModelChange)="onGroupSelectionChange(group, $event)"></mat-checkbox>
                      <div class="total-tip-fee">
                        <div>Total Tip</div>
                        <div>
                          Fee:
                          <span>
                            {{ group.totalTipFee | number:'1.2-2' }}
                          </span>
                        </div>
                      </div>      
                    </td>
                    <!-- PREDICTED GAS -->
                    <td class="group-value-cell" [attr.rowspan]="group.streams.length">      
                      {{ group.predictedGas | number:'1.0-2' }}      
                    </td>
                    @if (showPredictedGas2) {
                        <td
                          class="group-value-cell"
                          [attr.rowspan]="group.streams.length">
                      
                          {{ group.predictedGas2 | number:'1.0-2' }}
                      
                        </td>
                    }
                    <!-- FAT -->
                    <td class="group-value-cell" [attr.rowspan]="group.streams.length">      
                      {{ group.fat | number:'1.0-2' }}
                    </td>
                    <!-- CARBS -->
                    <td class="group-value-cell" [attr.rowspan]="group.streams.length">      
                      {{ group.carbs | number:'1.0-2' }}
                    </td>
                    <!-- PROTEIN -->
                    <td class="group-value-cell" [attr.rowspan]="group.streams.length">      
                      {{ group.protein | number:'1.0-2' }}
                    </td>
                  }
                  <!-- THESE REPEAT FOR EVERY STREAM -->
                  <td class="stream-name"> {{ stream.streamName }} </td>      
                  <td>{{ stream.tipFee | number:'1.2-2' }} </td>      
                  <td> {{ stream.haulingCost | number:'1.2-2' }}</td>      
                  <td>{{ stream.ciScore }}</td>
                </tr>
              }
            }      
          </tbody>      
        </table>      
      </div>
  </mat-dialog-content>  
  <mat-dialog-actions align="end">  
    <button mat-raised-button type="button" color="primary" (click)="onCancel()">Cancel </button>  
    <button mat-raised-button type="button" color="primary" [disabled]="isPreviousDayDisabled" (click)="onPreviousDay()"> Previous Day </button>  
    <button mat-raised-button type="button" color="primary" [disabled]="isNextDayDisabled" (click)="onNextDay()"> Next Day </button>  
    <button mat-raised-button color="primary" type="button" [disabled]="!canConfirm" (click)="onConfirm()">  
      Confirm
    </button>  
  </mat-dialog-actions>